export { default } from './SeoConfig.vue'
